import { localizedRouteGroup, routeGroup } from '#/routing/routes';

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewJobReferenceRoute = routeGroup.route(
  '-lang/-segment/:jobIdDashSlug',
  ['noSuggestions', 'listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewInternshipReferenceRoute = routeGroup.route(
  '-lang/-segment/:internshipIdDashSlug',
  ['listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewVolopReferenceRoute = routeGroup.route(
  '-lang/-segment/:volopIdDashSlug',
  ['listingApplicationTmpId'],
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewEventReferenceRoute = routeGroup.route(
  '-lang/-segment/:eventIdDashSlug',
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewOrgReferenceRoute = routeGroup.route(
  '-lang/-segment/:orgIdDashSlug',
);

/**
 * This is not a real route - the route is defined using constants instead of :lang/:segment
 * so that they're more accurate and easier to understand
 */
export const viewGroupReferenceRoute = routeGroup.route(
  '-lang/-segment/:orgIdDashSlug',
);

export const importedEventRoute = localizedRouteGroup.route(
  'imported-action-opps/:source/:eventId',
);
